import { render, staticRenderFns } from "./CmgCheckoutPage.vue?vue&type=template&id=808f50d2&scoped=true&lang=pug"
import script from "./cmg-checkout-page.ts?vue&type=script&lang=ts&external"
export * from "./cmg-checkout-page.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgCheckoutPage.vue?vue&type=style&index=0&id=808f50d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808f50d2",
  null
  
)

export default component.exports